<template lang="pug">
  a.b-footer-email(href="mailto:mail@teroom.ru")
    Icon._icon(name="mail" :class="{ green: greenIcon }")
    | mail@teroom.ru
</template>

<script>
export default {
  name: 'FooterEmail',
  props: {
    greenIcon: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.footer-email {
  display: flex;
  align-items: center;
  color: var(--color-accent);
  font-size: 12px;

  &__icon {
    display: block;
    width: 24px;
    height: 24px;
    margin-right: 10px;
    fill: var(--color-white);

    &.green {
      fill: var(--color-green-st);
    }
  }
}

</style>
